export default "__VITE_ASSET__DMVQ217S__"